
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-download",
      function () {
        return require("private-next-pages/software-download.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-download"])
      });
    }
  